import { createContext, ReactNode, useCallback, useEffect, useState } from "react";

interface IThemeContext {
    theme: 'light' | 'dark';
    updateTheme: (theme: 'light' | 'dark') => void;
}
export const ThemeContext = createContext({} as IThemeContext);

interface IProps {
    children: ReactNode;
}

export function ThemeProvider(props: IProps) {

    const [theme, setTheme] = useState<'light' | 'dark'>('light');

    useEffect(() => {

        let dataLSTheme: string | null = localStorage.getItem('@NotaMunicipio:theme');
        let localUserData: any = null;
        if (typeof dataLSTheme == 'string') {
            localUserData = JSON.parse(dataLSTheme);
        }

        if (localUserData) {
            setTheme(localUserData)
        } else {

            localStorage.setItem('@NotaMunicipio:theme', JSON.stringify('light'));

            setTheme('light');
            window.location.reload();
        }


    }, []);

    const updateTheme = useCallback((theme: 'light' | 'dark'): void => {

        localStorage.setItem('@NotaMunicipio:theme', JSON.stringify(theme));

        setTheme(theme);

    }, []);

    return (
        <ThemeContext.Provider value={{
            updateTheme, theme
        }}>
            {props.children}
        </ThemeContext.Provider>
    )
}
